import { Injectable } from '@angular/core'
import { SaleStatisticsQuery, SaleStatisticsQueryService, SaleStatisticsQueryVariables } from '@app-graphql/schema'
import { Observable } from 'rxjs'
import { Apollo } from 'apollo-angular'
@Injectable({ providedIn: 'root' })
export class SaleStatisticsService {

    constructor(
        private saleStatisticsQueryService: SaleStatisticsQueryService,
    ) {
    }

    public getSaleStatistics(input: SaleStatisticsQueryVariables): Observable<Apollo.QueryResult<SaleStatisticsQuery>> {
        return this.saleStatisticsQueryService.fetch({ variables: input })
    }
}
